var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAroplaneBed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.389,
    height: 19.823,
    viewBox: "0 0 43.389 19.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7704",
    "data-name": "Group 7704",
    transform: "translate(-12.611 -7.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "airplane",
    d: "M1.93,4.439a.509.509,0,0,1,.476.027L5.624,6.424a.508.508,0,0,0,.491.02l9.963-5A10.413,10.413,0,0,1,21.885.026s2.348-.247,2.1,1.412c-.243,1.6-5.449,3.8-7.042,4.263a.49.49,0,0,0-.277.21L13.411,11a.5.5,0,0,1-.241.2l-1.97.766a.5.5,0,0,1-.686-.433l-.165-2.7A.5.5,0,0,0,9.666,8.4a26.5,26.5,0,0,1-8.334,1.816c-.361,0,.4-.9.863-1.406a.492.492,0,0,0-.009-.673L.137,5.988a.5.5,0,0,1,.153-.793Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 12.611, 8.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_-_bed",
    "data-name": "icon - bed",
    transform: "translate(37 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M18.415,0H.585C.262,0,0,.356,0,.8V4.9c0,.439.262.795.585.795H.646V7.17c0,.11.066.2.146.2H2.326c.081,0,.146-.089.146-.2V5.693H16.528V7.17c0,.11.065.2.146.2h1.535c.081,0,.146-.089.146-.2V5.693h.061c.323,0,.585-.356.585-.795V.8c0-.439-.262-.8-.585-.8",
    transform: "translate(0 6.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M1.882,5.38h.47V3.26A.646.646,0,0,1,2.979,2.6H7.971A.646.646,0,0,1,8.6,3.26V5.38h1.8V3.26a.646.646,0,0,1,.627-.663h4.992a.646.646,0,0,1,.627.663V5.38h.47A1.938,1.938,0,0,1,19,7.368V1.989A1.938,1.938,0,0,0,17.118,0H1.882A1.937,1.937,0,0,0,0,1.989v5.38A1.937,1.937,0,0,1,1.882,5.38",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAroplaneBed);
export default __webpack_public_path__ + "static/media/aroplane-bed.e4d3c2d9ef7f0b153632b18b09eb4929.svg";
export { ForwardRef as ReactComponent };